export const availableColormaps = {
  algae: 45,
  amp: 49,
  balance: 53,
  Blues: 10,
  BrBG: 28,
  BuGn: 24,
  BuPu: 19,
  bwr: 36,
  cividis: 7,
  coolwarm: 35,
  curl: 55,
  deep: 43,
  delta: 54,
  dense: 44,
  diff: 56,
  GnBu: 20,
  gray: 42,
  Greens: 11,
  Greys: 8,
  haline: 39,
  hpluv: 6,
  hsluv: 5,
  ice: 41,
  inferno: 0,
  magma: 1,
  matter: 46,
  Oranges: 12,
  OrRd: 16,
  phase: 52,
  PiYG: 26,
  plasma: 2,
  PRGn: 27,
  PuBu: 21,
  PuBuGn: 23,
  PuOr: 29,
  Purples: 9,
  PuRd: 17,
  rain: 51,
  RdBu: 31,
  RdGy: 30,
  RdPu: 18,
  RdYlBu: 32,
  RdYlGn: 33,
  Reds: 13,
  seismic: 37,
  solar: 40,
  Spectral: 34,
  speed: 48,
  tarn: 57,
  tempo: 50,
  thermal: 38,
  turbid: 47,
  turbo: 4,
  viridis: 3,
  YlGn: 25,
  YlGnBu: 22,
  YlOrBr: 14,
  YlOrRd: 15,
} as const;

export type TColorMap = keyof typeof availableColormaps;
